var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    width: 250,
    height: 250,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "  \n\t.st0{fill:#31AD31;}\n\t.st1{fill:#47891D;}\n\t.st2{fill:#A7C958;}\n\t.st3{fill:#6ABC35;}\n\t.st4{fill:#57A525;}\n\t.st5{fill:#F9ED12;}\n\t.st6{fill:#B9E210;}\n\t.st7{fill:#8ABC2A;}\n\t.st8{enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.5 225Z",
    fill: "#a7c958"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M99.8 208.7 104.1 92.6c1.4-6.7 5-7 12.7-8.2l38.4-3.2 18.4-10.2-36.3-19.1-84.2 29c-17.6 6.5-12.9 24-7.9 30.5l49.3 105.3c2.2 5.3 7.2 8.1 12.9 8.3h0.9c0.2-0.3 0.3-0.6 0-0.7-6.5-1.3-8.8-8.4-8.5-15.5z",
    fill: "#b9e210"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m226.6 186.8c7.4-3 13.1-20.2 10.1-27.6-3-13.1-17.6-70-38.1-84.2l-18-4.7-19.1 4.8 21.3 42.9c5.8 5.5 2 11.6-3.5 17.4-6.5 4.9-43.5 52.3-65 84.3-2.4 2.6-3 4.1-5.8 5.3h0.4c1.6-0.1 4.3-0.3 6-0.9z",
    fill: "#57a525"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M95 89.6V210.5c0 7.6 5.8 13.9 13.3 14.5 3.5-0.3 6.8-1.9 9.3-4.4l83.6-87.4c5.6-5.8 5.4-14.9-0.4-20.4v0 0l-39.3-37.8h-51.9c-8.1 0-14.6 6.5-14.6 14.6 0-0.1 0 0 0 0z",
    fill: "#8abc2a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m198.6 75-11.4-27.8c-3-7.4-11.4-11-18.9-8v0h-0.1l-30.9 12.8 24.2 23z",
    fill: "#6abc35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m94.4 216-46-111.8c-3.1-7.4 0.5-15.9 7.9-19v0 0l81-33.3-23.9-22.9c-5.8-5.5-15-5.3-20.5 0.4L9.2 116.8c-5.6 5.8-5.4 15 0.4 20.6l87.5 83.6c2.7 2.6 6.3 4 10 4h0.4c-5.8-0.2-10.9-3.7-13.1-9z",
    fill: "#f9ed12"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m230.4 75h-31.8l34.5 84c3.1 7.4-0.5 15.9-7.9 19v0l-111.8 45.8c-1.5 0.6-3.5 1.1-5.1 1.2l122.1 0.1c8 0 14.5-6.5 14.5-14.5v0-121c0.1-8-6.4-14.6-14.5-14.6 0.1 0 0.1 0 0 0z",
    fill: "#47891d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0bce94c982953002c38b649b8eb9812c.svg";
export { ForwardRef as ReactComponent };